
// 第三方授权参数保存的localStorage key
const fromSource = 'fromSource';
const thirdChannelParam = 'thirdChannelParam';

export default {
  fromSource,
  thirdChannelParam
}
